import { render, staticRenderFns } from "./modell.vue?vue&type=template&id=687d1cb9&"
import script from "./modell.vue?vue&type=script&lang=js&"
export * from "./modell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports